import { render, staticRenderFns } from "./DisplayImages.vue?vue&type=template&id=66d50aca"
import script from "./DisplayImages.vue?vue&type=script&lang=js"
export * from "./DisplayImages.vue?vue&type=script&lang=js"
import style0 from "./DisplayImages.vue?vue&type=style&index=0&id=66d50aca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports